import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../packages/colors';

export const useStyles = makeStyles({
  root: {
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  heading: {
    fontFamily: 'Source Serif Pro',
    margin: 0,
  },
  btnGroupIcon: {
    color: colors.neutral700,
    backgroundColor: 'transparent',
    padding: '14px 18px',
    transition: '0s',
    fontSize: 14,
    height: 48,
    border: `1px solid ${colors.neutral200}`,
    '&:hover': {
      color: colors.white,
      backgroundColor: colors.neutral900,
      border: `1px solid ${colors.neutral900}`,
    },
  },
  btnGroupIconActive: {
    color: colors.white,
    border: `1px solid ${colors.neutral900}`,
    backgroundColor: colors.neutral900,
  },
  loadMoreBtn: {
    fontSize: 14,
    borderRadius: 6,
    '&:hover': {
      backgroundColor: colors.primary300,
      color: colors.primary500,
    },
  },
  noNotification: {
    height: 'unset',
  },
});
